import { Routes, RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { TermsAndConditionsComponent } from './terms-and-conditions.component';

const routes: Routes = [
    {
        path: 'home',
        component: TermsAndConditionsComponent,
    }
];

@NgModule({
    imports: [
        CommonModule,
        IonicModule,
        RouterModule.forChild(routes)
    ],
    declarations: [
        TermsAndConditionsComponent
    ],
    exports: [
        TermsAndConditionsComponent
    ]
})
export class TermsAndConditionsModule { }
